import { render } from "./modalGenerico.vue?vue&type=template&id=bd9d195e"
import script from "./modalGenerico.vue?vue&type=script&lang=js"
export * from "./modalGenerico.vue?vue&type=script&lang=js"

import "./modalGenerico.vue?vue&type=style&index=0&id=bd9d195e&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__